import { store } from '@/store'
import { isPast } from 'date-fns'

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  }
]

const guard = async function(to, from, next) {
  if ( //checkIfTokenNeedsRefresh()
    window.localStorage.getItem('token') !== null &&
    window.localStorage.getItem('tokenExpiration') !== null &&
    isPast(new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
  ) {
    store.dispatch('refreshToken').then(() => next())
  }else{
    return next()
  }
}

// const guard = function({ commit }, to, from, next) {
//
//   if (
//     window.localStorage.getItem('token') !== null &&
//     window.localStorage.getItem('tokenExpiration') !== null &&
//     isPast(new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
//   ) {
//       return new Promise((resolve, reject, next) => {
//         api
//           .refreshToken({token: JSON.parse(window.localStorage.getItem('refreshToken'))})
//           .then(response => {
//             if (response.status === 200) {
//               window.localStorage.setItem(
//                 'user',
//                 JSON.stringify(response.data.user)
//               )
//               window.localStorage.setItem(
//                 'token',
//                 JSON.stringify(response.data.token)
//               )
//               window.localStorage.setItem(
//                 'tokenExpiration',
//                 JSON.stringify(response.data.expiration)
//               )
//               window.localStorage.setItem(
//                 'refreshToken',
//                 JSON.stringify(response.data.refreshToken)
//               )
//               if(window.localStorage.getItem('selectedHotspot') == null){
//                 store.dispatch('setHotspot', response.data.user.hotspots[0])
//               }
//
//               commit(types.SAVE_USER, response.data.user)
//               commit(types.SAVE_TOKEN, response.data.token)
//               commit(types.EMAIL_VERIFIED, response.data.user.verified)
//               console.log('- TOKEN REFRESHED SUCCESSFULLY -')
//               return next()
//               resolve()
//
//             }
//           })
//           .catch(error => {
//             return next("/login");
//             handleError(error, commit, reject)
//           })
//       })
//     }else{ return next }
//
// }
